import React from "react";
import { Phone } from "lucide-react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "../ui/accordion";
import { FAQS, PHONE_DISPLAY, PHONE_TEL } from "../../data/mock";

export default function FAQ() {
  return (
    <section id="faq" className="bg-mist grain px-5 md:px-8 py-20 lg:py-28">
      <div className="max-w-[1240px] mx-auto grid lg:grid-cols-2 gap-12 lg:gap-16 items-start">
        <div className="lg:sticky lg:top-28">
          <p className="font-mono text-[12px] uppercase tracking-[0.18em] text-teal">
            06 <span className="text-navy/40">—</span> The questions
          </p>
          <h2 className="mt-5 font-grotesk font-bold leading-[1.0] tracking-tight text-[clamp(2.25rem,5vw,4rem)]">
            <span className="text-navy">Questions,</span>{" "}
            <span className="text-teal italic">answered.</span>
          </h2>
          <p className="mt-6 text-navy/70 text-lg leading-relaxed max-w-sm">
            Call to discuss the details of your business and the coverage you need.
          </p>
          <a
            href={`tel:${PHONE_TEL}`}
            className="mt-6 inline-flex items-center gap-2.5 bg-navy text-cream font-grotesk font-semibold px-6 py-3.5 rounded-full hover:bg-navy-800 transition-colors"
          >
            <Phone className="w-4 h-4" /> Call {PHONE_DISPLAY}
          </a>
        </div>

        <Accordion type="single" collapsible defaultValue="item-0" className="w-full">
          {FAQS.map((f, i) => (
            <AccordionItem
              key={i}
              value={`item-${i}`}
              className="border-b border-navy/12"
            >
              <AccordionTrigger className="text-left font-grotesk text-lg font-semibold text-navy hover:no-underline py-5">
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-navy/65 leading-relaxed text-[15px] pb-5">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
